import { Component, OnDestroy, OnInit } from "@angular/core"
import { FormControl, FormGroup } from "@angular/forms"
import { ActivatedRoute, Params, Router } from "@angular/router"
import { Subscription } from "rxjs"
import { GTMService } from "../../../services/gtm.service"

@Component({
    selector: "app-search-input",
    templateUrl: "./search-input.component.html",
    styleUrls: ["./search-input.component.scss"],
    standalone: false,
})
export class SearchInputComponent implements OnInit, OnDestroy {
    searchForm: FormGroup = new FormGroup({
        q: new FormControl(""),
    })
    public subscriptions: Subscription[] = []

    constructor(
        private gtmService: GTMService,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    public ngOnInit() {
        this.setFormValueFromQueryParams()
    }

    setFormValueFromQueryParams() {
        this.subscriptions.push(
            this.route.queryParams.subscribe((queryParams: Params) => {
                if (queryParams.hasOwnProperty("q")) {
                    setTimeout(() => {
                        const value = { q: queryParams.q }
                        this.searchForm.setValue(value)
                    }, 100)
                }
            })
        )
    }

    public onSearch() {
        const queryParams = { ...this.searchForm.value, page: "1" }
        this.router.navigate(["."], {
            queryParams,
            queryParamsHandling: "merge",
            relativeTo: this.route,
        })
        this.gtmService.pushEvent("search")
    }

    public ngOnDestroy() {
        this.subscriptions.map((subscription: Subscription) => subscription.unsubscribe())
    }
}
